/**
 * @file 保存图片列表的设置
 * @author liudy
 */
import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    element_id: number;
    sort_type: number;
    show_type: number;
}

export interface IOutput {
    result: number; // 1 ok, 0 失败
}

export const savePhotoListSetting = (data: IInput): Promise<IOutput> => {
    return fetchData(Api.PHOTO_SAVE_PHOTO_LIST_SETTING, data).then((res: IResponse<IOutput>) => {
        return res.data as IOutput;
    });
};
